import React from 'react';
import { TwoColumns } from './TwoColumns';
import { localize } from '../Util/L10n';

class Info extends React.Component {
  infoImg(imgSrc) {
    if (imgSrc) {
      return <img src={'/' + imgSrc} className="img-fluid" />;
    }
    return null;
  }

  render() {
    const { module } = this.props;
    return (
      <TwoColumns
        left={this.infoImg(module.images[0])}
        right={
          <div className="space-y">
            <h2>{module.name}</h2>
            <p
              dangerouslySetInnerHTML={{
                __html: module.description,
              }}
            />
            <div>
              <div className="font-weight-bold">Umfang</div>
              {localize('moduleEctspoints', module.ectsPoints)}
            </div>
            <div>
              <div className="font-weight-bold">Dauer</div>
              {localize('moduleSemester', module.semestersAmount)}
            </div>
          </div>
        }
      />
    );
  }
}

export default Info;
